import {AutocompleteContent, OptionsArea} from "../../webcomponents/autocomplete/autocompleteContent.component";
import {Value} from "../../webcomponents/core/Value";
import {WlAutoComplete} from "../../webcomponents/autocomplete/autocomplete.component";
import {AutocompleteApi, AutocompleteResult} from "./AutocompleteApi";

export class Autocomplete {
    private withProjects: boolean = false;
    private api = new AutocompleteApi();

    public register(submit: () => void, withProjects: boolean = true) {
        this.withProjects = withProjects;
        document.querySelectorAll<AutocompleteContent>(".js_geo-autocomplete-content")
            .forEach(it => {
                const autoCompleteComponent = it.parentElement as WlAutoComplete | undefined;
                this.api = new AutocompleteApi(autoCompleteComponent?.action || undefined);
                it.getMultiAreaItems = this.getSuggestions.bind(this)
                // @ts-ignore
                it.init(window['wl-multi-geo'] || [], window['wl-multi-geo-history'] || [])
            });

        document.querySelectorAll<AutocompleteContent>(".js_geo-autocomplete")
            .forEach(it => {
                it.addEventListener("wl-change", submit)
            });
    }

    private async getSuggestions(text: string): Promise<OptionsArea[]> {
        return await this.api
            .search(text, this.withProjects)
            .then(response => response.results.map(this.toValue.bind(this)))
    }

    private toValue(result: AutocompleteResult) {
        return new OptionsArea(
            result.header,
            result.options.map((option) => new Value(option.id, (option.subtext !== "") ? `${option.text}, ${option.subtext}` : option.text))
        )
    }
}
